import React, { useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AIChatbot from "./AIChatbot";
import CartDrawer from "./CartDrawer";
import { Toaster } from "../components/ui/sonner";
import { useAuth } from "../lib/auth";

export default function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  if (user?.must_change_password && location.pathname !== "/change-password") {
     return <Navigate to="/change-password" replace />;
  }
  return (
    <div className="min-h-screen bg-welljio-bg text-welljio-ink font-body">
      <Navbar />
      <main className="pt-20">
        <Outlet />
      </main>
      <Footer />
      <AIChatbot />
      <CartDrawer />
      <Toaster position="bottom-left" />
    </div>
  );
}
